import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(){}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): 
    Observable<HttpEvent<unknown>> {
      let cloneRequest = request;

        cloneRequest = request.clone({
          setHeaders:{
            "x-api-key": environment.xApiKey,
            "Authorization": environment.Authorization
          },
        })

      return next.handle(cloneRequest)
  }
}
